/**
 * Shared timing policy for the public AI Answer Readiness Score email OTP.
 *
 * The 15-minute window supports real inbox delivery and mobile hand-off without
 * weakening the separate 60-second resend rate limit.
 */
export const AUDIT_OTP_EXPIRY_SECONDS = 15 * 60;
export const AUDIT_OTP_RESEND_COOLDOWN_SECONDS = 60;

/**
 * Accept a six-digit code copied from email clients that may include spaces,
 * line breaks or invisible formatting characters. Only ASCII digits are ever
 * passed to the verifier; it still enforces exactly six digits afterwards.
 */
export function normaliseAuditOtpCode(raw: string): string {
  return raw.replace(/[^0-9]/g, "").slice(0, 6);
}

export function formatAuditOtpCountdown(seconds: number): string {
  const safeSeconds = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(safeSeconds / 60);
  const remainingSeconds = safeSeconds % 60;
  return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
}
